module.exports = __webpack_public_path__ + "img/btn-join-now-th.3d1e0dd6.png";